import { getCookie } from './utils';
import { initializeGenericNotificationFormHandler } from './disassembly/form';

export function initializeCreateNotificationForm(
    form,
    saveCallback = () => {},
) {
    if (!form) return;

    initializeGenericNotificationFormHandler({
        form,
        cancelButtonId: 'cancelCreateNotification',
        submitButtonId: 'createNotificationSubmit',
        subjectFieldId: 'id_notification_subject',
        recipientListFieldId: 'id_notification_recipient_id_list',
        recipientGroupsFieldId: 'id_notification_recipient_groups',
        successMessage: gettext('Powiadomienie zostało wysłane.'),
        fieldsToClearSelectors: [
            '#id_notification_recipient_id_list',
            '#id_notification_subject',
            '#id_notification_message',
            '#id_notification_recipient_groups',
        ],
        saveCallback,
    });

    const multiSelects = form.querySelectorAll('select[multiple]');

    multiSelects.forEach((select) => {
        if (window.forms && window.forms.initializeSelect) {
            window.forms.initializeSelect(
                select,
                { removeItemButton: true },
                true,
            );
        }
    });
}

export function initializeNotifications() {
    const notificationsContainer = document.getElementById(
        'notificationsContainer',
    );
    if (!notificationsContainer) return;
    const notificationsWindow = notificationsContainer.querySelector(
        '#notificationsWindow',
    );
    const notificationsList = notificationsWindow.querySelector('.window-body');
    const notificationsCounters =
        notificationsContainer.querySelectorAll('.counter');
    const notificationPing = notificationsContainer.querySelector('.ping');
    let notificationIntervalId = null;
    const closeButton = notificationsWindow.querySelector(
        '#userNotificationCloseBtn',
    );

    const userNotificationWindow = document.getElementById(
        'userNotificationWindow',
    );
    if (userNotificationWindow) {
        const userNotificationForm = userNotificationWindow.querySelector(
            '.user-notification-form',
        );
        initializeCreateNotificationForm(userNotificationForm);
    }
    const allSelects = document.querySelectorAll('select');
    allSelects.forEach((select) => {
        window.forms.initializeSelect(select);
    });

    function showWindow() {
        notificationPing.classList.add('hidden');
        notificationsWindow.classList.add('window-open');
    }

    function hideWindow() {
        notificationsWindow.classList.remove('window-open');
    }

    notificationsContainer.addEventListener('mouseenter', showWindow);
    notificationsContainer.addEventListener('mouseleave', hideWindow);

    if (closeButton) {
        closeButton.addEventListener('click', (event) => {
            event.stopPropagation();
            hideWindow();
        });
    }
    let previousNotificationCount = -1;

    function renderNotifications(notifications) {
        if (notifications.length === 0) {
            notificationsList.innerHTML = `<p class="empty">${gettext('Brak nowych powiadomień')}</p>`;
            return;
        }

        notificationsList.innerHTML = notifications
            .map((notification) => {
                const date = new Date(notification.created_at);
                return `
                <div class="notification">
                    <div class="notification-wrapper">
                        <small class="notification-date">${date.toLocaleString()}</small>
                        <h4 class="notification-subject">${notification.subject}</h4>
                        <p class="notification-message">${notification.message}</p>
                    </div>
                    <button class="mark-as-read" data-notification-id="${notification.id}">
                        <span class="icon-close-bold"></span>
                    </button>
                </div>
            `;
            })
            .join('');

        notificationsList
            .querySelectorAll('.mark-as-read')
            .forEach((button) => {
                button.addEventListener('click', (event) => {
                    event.preventDefault();
                    markNotificationAsRead(button.dataset.notificationId);
                });
            });
    }

    function updateNotificationCount(count) {
        notificationsCounters.forEach((counter) => {
            counter.textContent = count > 99 ? '99+' : count;
        });
        if (count > 0) {
            notificationPing.classList.remove('hidden');
        } else {
            notificationPing.classList.add('hidden');
        }
    }

    async function fetchNotifications() {
        const url = `/api/notifications/`;
        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            const data = await response.json();

            if (data.count !== previousNotificationCount) {
                document.dispatchEvent(new Event('notificationsPolled'));
                previousNotificationCount = data.count;
            }

            renderNotifications(data.items);
            updateNotificationCount(data.count);
        } catch (error) {
            console.error('Error fetching notifications:', error);
            notificationsList.innerHTML = '<p>Error loading notifications.</p>';
        }
    }

    async function markNotificationAsRead(notificationId) {
        const url = `/api/notifications/${notificationId}/mark_as_read/`;
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'X-CSRFToken': getCookie('csrftoken'),
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            await response.json();
            fetchNotifications();
        } catch (error) {
            console.error('Error marking notification as read:', error);
        }
    }

    function startNotificationPolling() {
        fetchNotifications();
        notificationIntervalId = setInterval(fetchNotifications, 15000);
    }

    function stopNotificationPolling() {
        if (notificationIntervalId) {
            clearInterval(notificationIntervalId);
            notificationIntervalId = null;
        }
    }

    startNotificationPolling();
    return stopNotificationPolling;
}
